import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import SingleAutocompleteSelectField, {
  SingleAutocompleteChoiceType
} from "@saleor/components/SingleAutocompleteSelectField";
// import SingleSelectField from "@saleor/components/SingleSelectField";
import { FormChange } from "@saleor/hooks/useForm";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { searchRider_search_edges } from "@saleor/motherOrders/types/searchRider";
import * as React from "react";
import { useIntl } from "react-intl";

import { onEnterPress } from "../../../utils/handlers/OnPressEnter";
import {
  orderRiderDispatchSearchAndValidation_orderRiderDispatchSearchAndValidation_orders_shippingAddress,
  orderRiderDispatchSearchAndValidation_orderRiderDispatchSearchAndValidation_orders_user
} from "../../types/orderRiderDispatchSearchAndValidation";

export interface Order {
  id: string;
  orderCode: string;
  shippingAddress: orderRiderDispatchSearchAndValidation_orderRiderDispatchSearchAndValidation_orders_shippingAddress;
  shippingSchedule: string;
  user: orderRiderDispatchSearchAndValidation_orderRiderDispatchSearchAndValidation_orders_user;
  isValid: boolean;
}
interface BatchAssignmentListHeadProps {
  change: FormChange;
  data: {
    riderId: string;
    riderName: string;
    order_code: string;
    orders: Order[];
  };
  riders: searchRider_search_edges[];
  onFetchMore: () => void;
  hasMore: boolean;
  loading: boolean;
  searchRider: (query: string) => void;
  validateOrder: (
    order_number: string,
    riderId: string,
    orders: Order[]
  ) => void | any;
  validateOrders: (orders: any[], riderId: string) => void | any;
}

const useStyles = makeStyles(
  () => ({
    btnOngoing: {
      "&:hover": {
        backgroundColor: "#f5f5f5 !important"
      },
      background: "#FFFFFF !important",
      border: "1px solid #E5E5E5 !important"
    },
    cardHeader: {
      //   "& > *": {
      //     flex: 1
      //   },
      //   display: "flex",
      //   flexDirection: "row",
      display: "flex",
      margin: "1.5em"
    },
    spacer: {
      flex: 3
    }
  }),
  { name: "DispatchListHead" }
);

const createSingleAutocompleteSelectHandler = (
  change: FormChange,
  setSelected: (value: string) => void,
  choices: SingleAutocompleteChoiceType[],
  event: React.ChangeEvent<any>
): FormChange => {
  change(event);

  const value = event.target.value;
  const choice = choices.find(category => category.value === value);
  setSelected(choice ? choice.label : value);
  return;
};

const BatchAssignmentListHead: React.FC<BatchAssignmentListHeadProps> = props => {
  const {
    change,
    data,
    riders,
    onFetchMore,
    hasMore,
    loading,
    searchRider,
    validateOrder,
    validateOrders
  } = props;
  const intl = useIntl();
  const classes = useStyles(props);
  const [riderDisplayName, setRiderDisplayName] = useStateFromProps("");

  const riderChoices =
    riders?.map(rider => ({
      label: `${rider.node.firstName} ${rider.node.lastName}`,
      value: rider.node.id
    })) || [];

  const riderSelectChange = async (event: React.ChangeEvent<any>) => {
    createSingleAutocompleteSelectHandler(
      change,
      setRiderDisplayName,
      riderChoices,
      event
    );

    // set array of validated orders in form state
    const result = await validateOrders(data.orders, data.riderId);
    change({
      target: {
        name: "orders",
        value: result
      }
    });
  };

  React.useEffect(() => {
    // set rider name in form state
    change({
      target: {
        name: "riderName",
        value: riderDisplayName
      }
    });
  }, [riderDisplayName]);

  const onAdd = async (order_number: string) => {
    const result = await validateOrder(order_number, data.riderId, data.orders);

    if (result) {
      change({
        target: {
          name: "orders",
          value: [...data.orders, result]
        }
      });
    }

    change({
      target: {
        name: "order_code",
        value: ""
      }
    });
  };

  return (
    <div className={classes.cardHeader}>
      <Grid container alignItems="flex-end" spacing={1}>
        <Grid item xs={12} sm={12} md={3}>
          {/* <span style={{ fontSize: "1.5em", whiteSpace: "nowrap" }}>
            Select Rider
          </span>{" "} */}
          {/* <SingleSelectField
            name="rider"
            value={data.rider}
            choices={riderChoices}
            onChange={change}
          /> */}
          <SingleAutocompleteSelectField
            // error={!!formErrors.permissionGroup}
            // helperText={getStaffErrorMessage(formErrors.permissionGroup, intl)}
            displayValue={!!data?.riderId ? riderDisplayName : ""}
            // disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Select Rider"
            })}
            choices={riderChoices ? riderChoices : []}
            name="riderId"
            value={data?.riderId}
            onChange={riderSelectChange}
            fetchChoices={searchRider}
            // data-test="permissionGroup"
            onFetchMore={onFetchMore}
            hasMore={hasMore}
            loading={loading}
            required
          />
        </Grid>
        <Grid item xs={false} sm={false} md={6}></Grid>
        <Grid item xs={12} sm={12} md={3}>
          <FormControl fullWidth>
            <InputLabel htmlFor="standard-adornment-order-code">
              Enter Order Number
            </InputLabel>
            <OutlinedInput
              id="standard-adornment-order-code"
              type="text"
              name="order_code"
              value={data.order_code}
              onChange={change}
              fullWidth
              disabled={!data.riderId}
              onKeyDown={keypress =>
                onEnterPress(
                  keypress,
                  () =>
                    data.order_code &&
                    onAdd((keypress.target as HTMLInputElement).value)
                )
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => data.order_code && onAdd(data.order_code)}
                    onMouseDown={e => e.preventDefault()}
                  >
                    <AddCircleIcon color="primary" />
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
          </FormControl>
        </Grid>
      </Grid>
      {/* <div>
        <span>Select Rider</span>
        <SingleSelectField choices={riderChoices} onChange={change} />
      </div>

      <div className={classes.spacer} />
      <TextField label="Enter Order Number" /> */}
    </div>
  );
};

export default BatchAssignmentListHead;
